export { default as InfoModal } from './InfoModal';
